import { bl_fi_item_branch_link_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';


export class FiItemBranchLinkImportFileHelperContainer extends BaseContainerModel {
  bl_fi_item_branch_link_import_file_helper: bl_fi_item_branch_link_import_file_helper_RowClass = new bl_fi_item_branch_link_import_file_helper_RowClass();
}
